export default __webpack_public_path__ + "static/char-s-46-zh-Hant-09cbfb5f678769d7109bb44ff73eee78.png";